import type { StateCreator } from 'zustand'

import { type RouterState, INITIAL_STATE } from './type'

const createRouterStateSlice: StateCreator<RouterState, [], [], RouterState> = (set) => ({
  routerState: INITIAL_STATE,
  setRouterState: (routerState) => set(() => ({ routerState: { routerState } })),
  resetRouterState: () => set(() => ({ routerState: INITIAL_STATE })),
})

export default createRouterStateSlice
